import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Button, Modal } from "react-bootstrap";
import './connections.less';
import {connectIntegration, disconnectIntegration} from "../../redux/actions/integrationsConnectionActions";
import dropboxIcon from './icons/dropbox.png';
import { notify } from 'common/Notification';
import DropboxAuthenticator from "./DropboxAuthenticator";

export default class DropboxSwitch extends React.Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired
  };

  state = {
    loading: false,
    showTypeChooser: false,
  };

  handleShowChooser = () => {
    this.setState({showTypeChooser: true});
  }

  handleHideChooser = () => {
    this.setState({showTypeChooser: false});
  }

  connectDropbox = (type) => {
    this.setState({showTypeChooser: false, loading: true});

    DropboxAuthenticator(type)
      .login({ state: { connection_type: type, redirect_host: window.location.host } })
      .then(
        ({ authResponse }) => {
          this.props.dispatch(connectIntegration('files', 'dropbox', authResponse));
          this.setState({ loading: false });
        },
        (res) => {
          const { code, message } = res.error;
          this.setState({ loading: false });
          notify.error(`Error connecting to Dropbox: [${code}] ${message || ''}`);
        }
      )
  }

  onClick = () => {
    const { connectionId, agreedToPricing } = this.props;

    if (connectionId === null) {
      this.handleShowChooser();
      return;
    }
    else {
      // just turn off the integration.
      this.props.dispatch(disconnectIntegration(connectionId));
    }
  };

  render() {
    const { connectionId, agreedToPricing } = this.props;

    const iconCls = `kloudless-switch ${connectionId ? 'on' : '' } ${agreedToPricing ? '' : 'hidden' }`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={dropboxIcon}
             alt="Dropbox Logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
              && <i className={"fa fa-circle-o-notch fa-spin"}
                    style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }} />
          }
        </div>

        <Modal show={this.state.showTypeChooser} onHide={this.handleHideChooser}>
          <Modal.Header closeButton>
            <Modal.Title>Choose Dropbox Integration Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <Panel.Heading>App Folder <strong>Dropbox/Apps/CourtDrive</strong></Panel.Heading>
              <Panel.Body>
                <p>Files will be uploaded to Dropbox under Apps/CourtDrive.</p>
                <p>
                  <strong>CourtDrive will not be able to read or write any files outside of this folder.</strong>
                </p>
                <Button bsStyle="primary" onClick={() => this.connectDropbox('appFolder')}>Choose App Folder</Button>
              </Panel.Body>
            </Panel>
            <Panel>
              <Panel.Heading>Full Access <strong>Dropbox/CourtDrive</strong></Panel.Heading>
              <Panel.Body>
                <p>Files will be uploaded under a folder name that you choose at the top of your Dropbox folder.</p>
                <p>
                  <strong>CourtDrive will need read/write access to your entire Dropbox for this.</strong>
                </p>
                <Button bsStyle="primary" onClick={() => this.connectDropbox('full')}>Choose Full Access</Button>
              </Panel.Body>
            </Panel>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/DropboxSwitch.jsx